import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-tender-list',
  templateUrl: './tender-list.component.html',
  styleUrls: ['./tender-list.component.scss']
})
export class TenderListComponent implements OnInit {
  editing = {};
  rows = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;

  rowsSel = [];
  selected = [];
  constructor( private commonfunction: CommonFunctionService,) { 
    this.GettipsList((data) => {
      // cache our list
      this.temp = _clone(data);
      this.rows = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
  
  });
  }
  GettipsList(cb) {
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    const req = new XMLHttpRequest();
    req.open('GET',environment.GetTenderListUrl+"?posSubscriptionId="+merchantdata.PosSubscriptionId);
  //   req.open('GET', `https://uatapi.fastswiff.com/virtualPOS/api/PrepaidCards/Manage?MerchantKeyId=3`);
  
    req.onload = () => {
        cb(JSON.parse(req.response));
    };
  
    req.send();
  }


  ngOnInit() {
  }

}
